import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { PageInformation } from '../business/page-information';

@Injectable({
    providedIn: 'root',
})
export class RxService {
    /**
     * Survey parameters store
     * @type {Rx.Subject<any>}
     */
    private static surveyParamsStore: Subject<any>;

    /**
     * Internal Messages store
     * @type {Rx.Subject<string>}
     */
    private static messagesStore: Subject<string>;

    /**
     * Internal Open contract store
     * @type {Rx.Subject<any>}
     */
    private static openedContractStore: Subject<any>;

    /**
     * Internal Open customer mapping store
     * @type {Rx.Subject<any>}
     */
    private static openedCustomerMappingStore: Subject<any>;

    /**
     * Internal Hide or show elco generic header store
     * @type {Rx.Subject<any>}
     */
    private static elcoGenericHeaderViewStore: Subject<any>;

    /**
     * Internal message from nec store
     * @type {Rx.Subject<any>}
     */
    private static messageFromNecStore: Subject<any>;

    /**
     * Internal Title store
     * @type {Rx.Subject<string>}
     */
    private static titleStore: Subject<string>;

    /**
     * Internal Error store
     * @type {Rx.Subject<any>}
     */
    private static errorStore: Subject<any>;

    /**
     * Internal Back route store
     * @type {Rx.Subject<string>}
     */
    private static backRouteStore: Subject<string>;

    /**
     * Internal Console store
     * @type {Rx.Subject<string>}
     */
    private static consoleStore: Subject<any>;
    /**
     * Internal Hide or show sticky menu store
     * @type {Rx.Subject<any>}
     */
    private static menuBarViewStore: Subject<any>;

    private static pageLoadedStore: Subject<PageInformation>;

    /**
     * Messages store getter
     * @returns {Rx.Subject<string>}
     */
    public static getMessagesStore(): Subject<string> {
        if (!RxService.messagesStore) {
            RxService.messagesStore = new Subject<string>();
        }
        return RxService.messagesStore;
    }

    /**
     * Opens contract store getter
     * @returns {Rx.Subject<any>}
     */
    public static getOpenedContractStore(): Subject<any> {
        if (!RxService.openedContractStore) {
            RxService.openedContractStore = new Subject<any>();
        }
        return RxService.openedContractStore;
    }

    /**
     * Opens customer mapping store getter
     * @returns {Rx.Subject<any>}
     */
    public static getOpenedCustomerMappingStore(): Subject<any> {
        if (!RxService.openedCustomerMappingStore) {
            RxService.openedCustomerMappingStore = new Subject<any>();
        }
        return RxService.openedCustomerMappingStore;
    }

    /**
     * Hides or shows elco header store getter
     * @returns {Rx.Subject<any>}
     */
    public static getElcoGenericHeaderViewStore(): Subject<any> {
        if (!RxService.elcoGenericHeaderViewStore) {
            RxService.elcoGenericHeaderViewStore = new Subject<any>();
        }
        return RxService.elcoGenericHeaderViewStore;
    }

    /**
     *  Message from nec store getter
     * @returns {Rx.Subject<any>}
     */
    public static getMessageFromNecStore(): Subject<any> {
        if (!RxService.messageFromNecStore) {
            RxService.messageFromNecStore = new Subject<any>();
        }
        return RxService.messageFromNecStore;
    }

    /**
     * Title store getter
     * @returns {Rx.Subject<string>}
     */
    public static getTitleStore(): Subject<string> {
        if (!RxService.titleStore) {
            RxService.titleStore = new Subject<string>();
        }
        return RxService.titleStore;
    }

    /**
     * Error store getter
     * @returns {Rx.Subject<any>}
     */
    public static getErrorStore(): Subject<any> {
        if (!RxService.errorStore) {
            RxService.errorStore = new Subject<any>();
        }
        return RxService.errorStore;
    }

    /**
     * Back route store getter
     * @returns {Rx.Subject<string>}
     */
    public static getBackRouteStore(): Subject<string> {
        if (!RxService.backRouteStore) {
            RxService.backRouteStore = new Subject<string>();
        }
        return RxService.backRouteStore;
    }

    /**
     * Back route store getter
     * @returns {Rx.Subject<string>}
     */
    public static getConsoleStore(): Subject<any> {
        if (!RxService.consoleStore) {
            RxService.consoleStore = new Subject<any>();
        }
        return RxService.consoleStore;
    }

    /**
     * Survey parameters store getter
     * @returns {Rx.Subject<any>}
     */
    public static getSurveyParamsStore(): Subject<any> {
        if (!RxService.surveyParamsStore) {
            RxService.surveyParamsStore = new Subject<any>();
        }
        return RxService.surveyParamsStore;
    }

    /**
     * Hides or shows menu bar store getter
     * @returns {Rx.Subject<any>}
     */
    public static getMenuBarViewStore(): Subject<any> {
        if (!RxService.menuBarViewStore) {
            RxService.menuBarViewStore = new Subject<any>();
        }
        return RxService.menuBarViewStore;
    }

    public static getPageLoadedStore() {
        return (RxService.pageLoadedStore ??= new Subject<PageInformation>());
    }
}
